const os = require('os');
const networkInterfaces = os.networkInterfaces();
export default function() {
  let macA;
  for (let key in networkInterfaces) {
    networkInterfaces[key].forEach((item: { mac: string; }) => {
      if (item.mac && item.mac != '00:00:00:00:00:00') {
        macA = item.mac;
      }
    });
  }
  return macA;
}
